import { createContext } from 'react';

export const ProtesisTramitesContext = createContext();
